import React from "react";
import BodyError from "./BodyError";

const ErrorNotFound = () => {
    return(
        <>
            <BodyError/>
        </>
    )
}
export default ErrorNotFound
